import { FunctionComponent } from 'react';
import { Route, Routes } from 'react-router-dom';
import { RequireAuth, useAuth } from '@sky/xerxes-client-react';
import { LinkContainer } from 'react-router-bootstrap'
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { ProfilePage, UserDetailsPage, UserIndexPage, SingleSignOn, SignOut, Loading, NotAuthorised, NotFound } from './pages';
import { hasAdminGroupMembership } from './utils';

const Application: FunctionComponent = () => {
  const { signIn, signOut, isLoading, isAuthenticated, token } = useAuth();
  const isAdminGroupMember: boolean = hasAdminGroupMembership(token);

  return (
    <div className="mb-4">
      <Navbar bg="light" expand="lg" style={{ marginBottom: 20 }}>
        <Container>
          <LinkContainer to="/">
            <Navbar.Brand>
              Xerxes Access Manager
              {' '}
              <small className="text-muted" style={{ fontSize: '75%'}}>
                v{process.env.REACT_APP_VERSION}
              </small>
            </Navbar.Brand>
          </LinkContainer>

          { isAdminGroupMember && (
            <Nav>
              <LinkContainer to="/users">
                <Nav.Link>
                  User Management
                </Nav.Link>
              </LinkContainer>
            </Nav>
          )}

          <Nav>
            { !isAuthenticated && !isLoading && (
              <Nav.Item>
                <Button variant="outline-primary" size="sm" onClick={() => signIn('SkyAzureAD')}>
                  Sign In
                </Button>
              </Nav.Item>
            )}
            { isAuthenticated && !isLoading && (
              <Nav.Item>
                <Button variant="outline-primary" size="sm" onClick={() => signOut()}>
                  Sign Out
                </Button>
              </Nav.Item>
            )}
          </Nav>
        </Container>
      </Navbar>

      <Routes>
        <Route path="/" element={<RequireAuth onLoading={<Loading />} children={<ProfilePage />} />} />

        { isAdminGroupMember && 
          <>
            <Route path="/users" element={<RequireAuth onLoading={<Loading />} children={<UserIndexPage />} />} />
            <Route path="/users/:username" element={<RequireAuth onLoading={<Loading />} children={<UserDetailsPage />} />} />
          </>        
        }

        <Route path="/sso" element={<SingleSignOn />} />
        <Route path="/logout" element={<SignOut />} />
        <Route path="/unauthorised" element={<NotAuthorised />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default Application;
